import React, { useState, useEffect } from 'react';
import StreamPreviewCard from '../components/Streaming/StreamPreviewCard.tsx'; // Asegúrate que la ruta sea correcta
import { apiUrl } from '../utils/constants.ts'; // Asumiendo que apiUrl está definido aquí
import { FaSpinner } from 'react-icons/fa';

interface ActiveStreamInfo {
  tokenAddress: string;
  ownerAddress: string;
  chainId: number; // <-- Add chainId
  // Añade aquí cualquier otra información que devuelva tu API, ej:
  // tokenName?: string;
  // viewerCount?: number;
}

const ActiveStreams: React.FC = () => {
  const [activeStreams, setActiveStreams] = useState<ActiveStreamInfo[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  // Remove a token from list when preview reports no live tracks
  const removeStream = (tokenAddress: string) => {
    setActiveStreams(prev => prev.filter(s => s.tokenAddress !== tokenAddress))
    console.log('🛠️ ActiveStreams → removed inactive', tokenAddress)
  }

  useEffect(() => {
    const fetchActiveStreams = async () => {
      setLoading(true);
      setError(null);
      try {
        // Asume que tienes un endpoint '/api/active-streams' que devuelve ActiveStreamInfo[]
        const response = await fetch(`${apiUrl}/api/active-streams`);
        if (!response.ok) {
          throw new Error(`Error fetching streams: ${response.statusText}`);
        }
        const data: ActiveStreamInfo[] = await response.json();
        setActiveStreams(data);
        console.log('🛠️ fetchActiveStreams → data:', data);  // << LOG raw data
      } catch (err: any) {
        console.error("Failed to fetch active streams:", err);
        setError(err.message || 'Failed to load streams.');
      } finally {
        setLoading(false);
      }
    };

    fetchActiveStreams();
    // Opcional: Añadir un intervalo para refrescar la lista periódicamente
    // const intervalId = setInterval(fetchActiveStreams, 30000); // Refrescar cada 30 segundos
    // return () => clearInterval(intervalId);
  }, []);

  // LOG on each render
  console.log('🛠️ ActiveStreams render → loading:', loading, 'error:', error, 'activeStreams:', activeStreams);

  return (
    <div className="min-h-screen bg-[#010101] text-white">
     
      <div className="pt-[120px] px-4 max-w-7xl mx-auto"> {/* Ajusta pt según la altura de TopBar */}
        <h1 className="text-3xl font-bold mb-6 text-center text-[#45c0be]">Active Streams</h1>

        {loading && (
          <div className="flex items-center justify-center mt-10">
            <FaSpinner className="animate-spin text-4xl text-[#45c0be]" />
            <span className="ml-3 text-xl">Loading streams...</span>
          </div>
        )}

        {error && (
          <div className="mt-10 text-center text-red-500">
            <p>Error: {error}</p>
          </div>
        )}

        {/* Solo renderizar la grilla si hay streams */}
        {!loading && !error && activeStreams.length > 0 && (
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {activeStreams.map((stream) => (
              <StreamPreviewCard
                key={stream.tokenAddress} // Usar tokenAddress como key asumiendo que es único por stream
                tokenAddress={stream.tokenAddress}
                ownerAddress={stream.ownerAddress}
                chainId={stream.chainId} // <-- Pass chainId
                onInactive={() => removeStream(stream.tokenAddress)}  // << pass callback
                // Pasa cualquier otra info necesaria al card
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ActiveStreams;
